module.exports = __webpack_public_path__ + "img/746@2x.cb2bca0f.png";